import React from 'react';
import sortlyContext from './sortlyContext';

export default function useItems() {
  const { items } = React.useContext(sortlyContext);
  return items;
}
